import { Box, Grid, Stack, TableCell, TableRow, Typography } from "@mui/material";
import { useAppDispatch } from "../../assets/hooks";
// import ReusableTable from "../../genericComponents/reusableTable";
// import { setPopup } from "../../store/Slices/popupSlice";
import {  UniversityListObj } from "../../types/types";
import {  setWordCase } from "../../assets/library";
// import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";
import { setPopup } from "../../store/slices/popupSlice";
import CustomCard from "../../components/customCard";
import ReusableTable from "../../components/reusableTable";
// import CustomCard from "../../genericComponents/customCard";

const Universities = (props: any) => {
  const universityRows = [
    { key: "university", name: "University", width: 180 },
    { key: "country", name: "Country", width: 150 },
    { key: "state", name: "State", width: 100 },
    // { key: "ranking", name: "Ranking", width: 100 },
    { key: "Type", name: "Type", width: 80 },
    { key: "costOfLiving", name: "Cost Of Living", width: 150 },
    { key: "coursesOffered", name: "Programs Offered", width: 100 },
  ];

  const dispatch = useAppDispatch();

  const UniversityData = () => {
    const navigate = useNavigate();

    return (
      <>
        {
         props.loading ? 
         (
           <TableRow>
             <TableCell colSpan={universityRows.length}>
               <Typography textAlign="center">Loading ...</Typography>
             </TableCell>
           </TableRow>
         ) :
        props.list?.length > 0 ? (
          props.list.map((university: UniversityListObj, i: number) => (
            <TableRow
              key={university._id}
              sx={{
                "& .MuiTableCell-root": {
                  padding: "8px",
                  border: "none",
                },
                verticalAlign: "top",
              }}
            >
              {/* <TableCell sx={{ textAlign: "center" }}>{i + 1}</TableCell> */}
              <TableCell
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "#3B3F76", fontWeight: "500" },
                }}
                onClick={() => {
                  dispatch(
                    setPopup({
                      show: true,
                      data: {
                        container: {
                          name: "universityPopup",
                          data: university._id,
                          dimensions: {
                            width: "80%",
                            // height: "80%",
                          },
                        },
                        type: "custom",
                      },
                    })
                  );
                }}
              >
                <div style={{ display: "flex", gap: "10px",paddingLeft: "1rem" }}>
                  <img
                    src={university?.logoSrc}
                    alt="logo"
                    style={{
                      height: "1.5rem",
                      width: "1.5rem",
                      borderRadius: "50%",
                    }}
                  />
                  {university?.name}
                </div>
              </TableCell>
              <TableCell sx={{
                  textAlign: "center",
                  color: "#6E6E6E",
              }}>{university?.location?.country}</TableCell>
              <TableCell sx={{
                  textAlign: "center",
                  color: "#6E6E6E",
              }}>{university?.location?.state}</TableCell>
              {/* <TableCell>
                {/* {university.ranking?.map((item) => (
                  <div>
                    <Typography fontSize="0.9rem">
                      {normalizeType(item?.source)} {item?.rank}
                    </Typography>
                  </div>
                ))} */}
              {/* </TableCell> */}
              <TableCell sx={{
                  textAlign: "center",
                  color: "#6E6E6E",
              }}>{setWordCase(university?.type)}</TableCell>

              <TableCell sx={{textAlign:"center"}}>
                {university.cost?.find((item) => item.name === "Living Cost")
                  ? `${university.currency?.symbol || ""}${university.cost
                      .find((item) => item.name === "Living Cost")
                      ?.lowerLimit?.toLocaleString("en-US")} - ${
                      university.currency?.symbol || ""
                    }${university.cost
                      .find((item) => item.name === "Living Cost")
                      ?.upperLimit?.toLocaleString("en-US")}`
                  : "Not available"}
              </TableCell>
              <TableCell
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  "&:hover":{
                    color:"#3b3f76"
                  },
                  cursor:"pointer"
                }}
                onClick={() =>{
                  const subDisUrl = `activeTab=${JSON.stringify(
                      "courses"
                    )}&FilterData=${JSON.stringify([
                      {
                        type: "universityId",
                        data: [
                          { name: university?.name, value: university?._id },
                        ],
                      },
                    ])}&page=${JSON.stringify(1)}&search=${JSON.stringify(
                      ""
                    )}`
                const subDisciUrl = window.btoa(subDisUrl);
                navigate(`/explore?${subDisciUrl}`);
                }}
              >
                {university?.courses}
                {/* <EastIcon
                  sx={{
                    ml: 1,
                    color: "#3B3F76",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    navigate(
                      `/explore?activeTab=${JSON.stringify(
                        "courses"
                      )}&FilterData=${JSON.stringify([
                        {
                          type: "universityId",
                          data: [
                            { name: university?.name, value: university?._id },
                          ],
                        },
                      ])}&page=${JSON.stringify(1)}&search=${JSON.stringify(
                        ""
                      )}`
                    )
                  }
                /> */}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={universityRows.length}>
              <Typography textAlign="center">No data available</Typography>
            </TableCell>
          </TableRow>
        )}
      </>
    );
  };
  const Card = (data: any) => {
    const item = data.data;

    return (
      <div>
        <CustomCard title="" i={0}>
          <Box
          // sx={{display:"flex",gap:"1rem"}}
            onClick={() => {
              dispatch(
                setPopup({
                  show: true,
                  data: {
                    container: {
                      name: "universityPopup",
                      data: item._id,
                      dimensions: {
                        width: "80%",
                        // height:"80%"
                      },
                    },
                    type: "custom",
                  },
                })
              );
            }}
          >
            <Box sx={{display:"flex",gap:"10px",width:"100%"}}>
              <img
                src={item?.logoSrc}
                alt="logo"
                style={{
                  width: "2rem",
                  height: "2rem",
                  marginRight: "5px",
                  borderRadius: "50%",
                }}
              />
              <Stack sx={{ }} spacing={1}>
              <Typography
                  fontSize="0.9rem"
                  sx={{
                    // height: "2rem",
                    fontSize: { xs: "13px", lg: "15px" },
                  }}
                >
                  {item?.name}
                </Typography>
              <Typography fontSize="0.8rem" >
              {item?.location?.state} , 
                {item?.location?.country}
              </Typography>
              <Typography fontSize="0.8rem" color="#8D8B8B">
              {setWordCase(item?.type)} |  {item.cost?.find((item:any) => item.name === "Living Cost")
                  ? `${item.currency?.symbol || ""}${item.cost
                      .find((item:any) => item.name === "Living Cost")
                      ?.lowerLimit?.toLocaleString("en-US")} - ${
                      item.currency?.symbol || ""
                    }${item.cost
                      .find((item:any) => item.name === "Living Cost")
                      ?.upperLimit?.toLocaleString("en-US")}`
                  : "Not available"}
              </Typography>
            </Stack>
            </Box>

          </Box>
         
        </CustomCard>
      </div>
    );
  };
  const UniversityCards = () =>{
    return(
      <div>

            <Box >
          <Grid
            container
            spacing={2}
            sx={{
              // maxHeight: "81vh",
              overflowY: "scroll",
            }}
          >
          {props?.list?.length > 0 ? (
          props?.list?.map((course: any, i: number) => (
            <Grid item xs={12} sm={6}>
            <Card data={course} key={course._id} />
            </Grid>
           ))
           ) :""}
         
          </Grid>
        </Box>
      </div>
    )
  }
  return (
    <Box sx={{ px: "1rem"}}>
      <Box sx={{display:{xs:"none",lg:"block"}}}>
      <ReusableTable columns={universityRows} data={<UniversityData />} />
           </Box>
           <Box sx={{display:{xs:"block",lg:"none"}}}>
             <UniversityCards/>
           </Box>
    </Box>
  );
};

export default Universities;
